import React from "react";
import style from "./secondTopNav.module.css";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";
import { useNavigate } from "react-router-dom";
const SecondTopNavbar = () => {
  const { otherData, fontSize } = useDashBoardData();
  const navigate = useNavigate("");

  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <div className={`${style.second_top_navbar_main}`}>
      <div className={`${style.second_top_nav_left}`}>
        <div
          className={`${style.second_top_n_l_first}`}
          onClick={handleNavigate}
          style={{ cursor: "pointer" }}
        >
          <img
            src={require("../../assets/images/logo.png")}
            alt="logo"
            className={`img-fluid ${style.second_top_nav_logo}`}
          />
        </div>
        <div className={`${style.second_top_n_l_second}`}>
          <h6
            // style={{ fontSize: `${fontSize}px` }}
            className={`${style.second_top_n_l_second_title}`}
          >
            {otherData?.village_name} ग्रामपंचायत
          </h6>
          <p className={`${style.second_top_n_l_second_para}`}>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <mask
                  id="mask0_59_4043"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="23.7822" height="23.7822" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_59_4043)">
                  <path
                    d="M5.25956 20.314C4.75901 20.314 4.33532 20.1405 3.9885 19.7937C3.64167 19.4469 3.46826 19.0232 3.46826 18.5227V5.25956C3.46826 4.75901 3.64167 4.33532 3.9885 3.9885C4.33532 3.64167 4.75901 3.46826 5.25956 3.46826H18.5227C19.0232 3.46826 19.4469 3.64167 19.7937 3.9885C20.1405 4.33532 20.314 4.75901 20.314 5.25956V18.5227C20.314 19.0232 20.1405 19.4469 19.7937 19.7937C19.4469 20.1405 19.0232 20.314 18.5227 20.314H5.25956ZM11.8911 17.2173C13.3262 16.0037 14.3952 14.8752 15.0979 13.8318C15.8007 12.7884 16.1521 11.8227 16.1521 10.9347C16.1521 9.58794 15.7239 8.52294 14.8677 7.73972C14.0114 6.95653 13.0192 6.56493 11.8911 6.56493C10.763 6.56493 9.7708 6.95673 8.91454 7.74034C8.05828 8.52397 7.63015 9.5885 7.63015 10.9339C7.63015 11.8211 7.98269 12.7864 8.68777 13.8301C9.39284 14.8737 10.4606 16.0028 11.8911 17.2173ZM11.8898 12.1198C11.5693 12.1198 11.2988 12.0091 11.0784 11.7878C10.8579 11.5665 10.7477 11.2956 10.7477 10.9751C10.7477 10.6546 10.8584 10.3841 11.0797 10.1637C11.301 9.94326 11.5719 9.83306 11.8924 9.83306C12.213 9.83306 12.4834 9.94371 12.7038 10.165C12.9243 10.3863 13.0345 10.6572 13.0345 10.9777C13.0345 11.2983 12.9238 11.5688 12.7025 11.7892C12.4812 12.0096 12.2103 12.1198 11.8898 12.1198Z"
                    fill="#109299"
                  />
                </g>
              </svg>
            </span>
            <span>
              ता. {otherData?.taluka_name} जि. {otherData?.district_name}
            </span>
          </p>
        </div>
      </div>
      <div className={`${style.second_top_nav_right}`}>
        <div className={`${style.second_top_n_r_first}`}>
          <img
            src={require("../../assets/images/icons/governer-icon.png")}
            alt="logo"
            className={`img-fluid ${style.second_top_nav_c_img_1}`}
          />
        </div>
        <div className={`${style.second_top_n_r_first}`}>
          <img
            src={require("../../assets/images/icons/gov-2.png")}
            alt="logo"
            className={`img-fluid ${style.second_top_nav_c_img_2}`}
          />
        </div>
        <div className={`${style.second_top_n_r_first}`}>
          <img
            src={require("../../assets/images/icons/gov-3.png")}
            alt="logo"
            className={`img-fluid ${style.second_top_nav_c_img_3}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SecondTopNavbar;
